import { ListArtifactsRequestSchema, ListArtifactsResponseSchema } from './list-artifacts.schema';
/**
 * List Artifacts Endpoint Contract
 * Retrieves all artifacts in the organization
 */ export const listArtifactsContract = {
    method: 'GET',
    path: '/api/v2/artifact',
    description: 'Retrieve all artifacts in the organization',
    requestSchema: ListArtifactsRequestSchema,
    responseSchema: ListArtifactsResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            401: 'Unauthorized - user not authenticated'
        }
    }
};

//# sourceMappingURL=list-artifacts.contract.js.map